const DeliveryZonesScope = {
  ALL: "all",
  GEOGRAPHICAL_ZONE: "geographical-zone",
  DISTANCE_IN_KM: "distance-in-km",
} as const;

type DeliveryZonesScope =
  typeof DeliveryZonesScope[keyof typeof DeliveryZonesScope];

export default DeliveryZonesScope;
